module.exports = __webpack_public_path__ + "static/media/logo-mestrealvaro.f470896a.png";